import {AgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'
import {makeCAPIRequest} from '@github-ui/copilot-chat/utils/copilot-chat-helpers'

interface FetchWithAuthOptions {
  path: string
  method?: 'GET' | 'POST' | 'DELETE' | 'PATCH'
  streamingResponse?: boolean
}

export async function fetchCAPI({
  path,
  method = 'GET',
  streamingResponse = false,
}: FetchWithAuthOptions): Promise<Response> {
  const tokenProvider = new AgentSessionsTokenProvider()
  const token = await tokenProvider.getAuthToken()

  if (!token) {
    throw new Error('No token available')
  }

  const response = await makeCAPIRequest({
    authToken: token,
    basePath: 'https://api.githubcopilot.com',
    method,
    path,
    streamingResponse,
  })

  if (!response.ok) {
    throw new Error('Failed to fetch agent sessions')
  }

  return response
}
